import * as React from "react";
const SvgButtonSuccess = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	dimensions: "0 0 24 24",
	viewBox: "0 0 24 24",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	stroke: "#fff",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, /* @__PURE__ */ React.createElement("path", { d: "M6 13.223L8.45 16.7a1.05 1.05 0 001.707.051L18 6.828" }), /* @__PURE__ */ React.createElement("path", { d: "M12 .749c6.213 0 11.25 5.037 11.25 11.25S18.213 23.249 12 23.249.75 18.212.75 11.999 5.787.749 12 .749z" })));
export { SvgButtonSuccess as ReactComponent };
